import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { ENTER, SPACE } from '../../constants';
import { callAll } from '../../utils';
import { useTooltipContext } from './Context';
const Trigger = forwardRef(({ as: Element = 'button', className, children, render, onClick = () => { }, onKeyDown = () => { }, onFocus = () => { }, onBlur = () => { }, onMouseEnter = () => { }, onMouseLeave = () => { }, ...rest }, ref) => {
    const { id, isOpen, setIsOpen } = useTooltipContext();
    const handleClick = (evt) => {
        evt.preventDefault();
        setIsOpen(isOpen => !isOpen);
    };
    const handleFocus = () => setIsOpen(true);
    const handleBlur = () => setIsOpen(false);
    const handleKeyDown = (evt) => {
        if (evt.key === SPACE || evt.key === ENTER) {
            evt.preventDefault();
            setIsOpen(isOpen => !isOpen);
        }
    };
    return (_jsx(Element, { "aria-describedby": `${id}-content`, className: typeof className === 'function' ? className({ isOpen }) : className, onBlur: callAll(onBlur, handleBlur), onClick: callAll(onClick, handleClick), onFocus: callAll(onFocus, handleFocus), onKeyDown: callAll(onKeyDown, handleKeyDown), onMouseEnter: callAll(onMouseEnter, handleFocus), onMouseLeave: callAll(onMouseLeave, handleBlur), ref: ref, tabIndex: 0, ...rest, children: render ? render({ isOpen }) : children }));
});
Trigger.displayName = 'Trigger';
export { Trigger };
//# sourceMappingURL=Trigger.js.map